import { AnimatePresence, motion } from 'framer-motion';
import { Loader, UserRound } from 'lucide-react';
import React, { useRef } from 'react';
import { cn } from '~/lib/utils';
//import { normalizeHighlightedText } from '~/services/utils';

import { Avatar, AvatarImage } from '../ui/avatar';
//import { Button } from '../ui/button';
//import { Input } from '../ui/input';

interface ChatListProps {
    messages: any[];

    isFetching: boolean;
}

export default function ChatList({ isFetching, messages }: ChatListProps) {
    const messagesContainerRef = useRef<HTMLDivElement>(null);
    const dataItems = isFetching
        ? [...messages, { isMine: false, isTyping: true }]
        : messages;

    React.useEffect(() => {
        if (messagesContainerRef.current) {
            messagesContainerRef.current.scrollTop =
                messagesContainerRef.current.scrollHeight;
        }
    }, [messages]);

    function getItemText(item) {
        if (item.isEmpty) {
            return `Sorry, I could not find an answer to your query.`; //`Sorry, I could not find an answer to your query. Would you like to submit a support request?`;
        }

        return (
            item.message ||
            item.error ||
            (item.isTyping && 'Assistant is typing...')
        );
    }

    return (
        <div
            ref={messagesContainerRef}
            className='w-full overflow-y-auto overflow-x-hidden h-full flex flex-col'>
            <AnimatePresence>
                {dataItems.map((item, index) => (
                    <motion.div
                        key={index}
                        layout
                        initial={{ opacity: 0, scale: 1, y: 50, x: 0 }}
                        animate={{ opacity: 1, scale: 1, y: 0, x: 0 }}
                        exit={{ opacity: 0, scale: 1, y: 1, x: 0 }}
                        transition={{
                            opacity: { duration: 0.1 },
                            layout: {
                                type: 'spring',
                                bounce: 0.3,
                                duration: dataItems.indexOf(item) * 0.05 + 0.2,
                            },
                        }}
                        style={{
                            originX: 0.5,
                            originY: 0.5,
                        }}
                        className={cn(
                            'flex flex-col gap-2 p-2 whitespace-pre-wrap',
                            item.isMine ? 'items-end' : 'items-start',
                        )}>
                        <div className='flex gap-3 items-center'>
                            {!item.isMine && (
                                <Avatar className='flex justify-center items-center border-2 border-slate-200 bg-white'>
                                    <AvatarImage
                                        src={'/assets/64.png'}
                                        alt={`AI Perfect Assistant Logo`}
                                        className='w-[24px] h-[24px]'
                                    />
                                </Avatar>
                            )}
                            <div className='grid gap-y-1'>
                                <span
                                    className={
                                        'bg-slate-200 p-3 rounded-md max-w-md flex items-center'
                                    }>
                                    {item.isTyping && (
                                        <Loader className='w-3 h-3 mr-2 animate-spin' />
                                    )}
                                    <span>{getItemText(item)}</span>
                                </span>
                            </div>
                            {item.isMine && (
                                <Avatar className='flex justify-center items-center bg-slate-300 transition-all group-hover:scale-110'>
                                    <UserRound />
                                </Avatar>
                            )}
                        </div>
                    </motion.div>
                ))}
            </AnimatePresence>
        </div>
    );
}
